// Collapsed FAB diameter (px). Shrinks when toolbox or a portaled MUI Drawer is
// open. radius = size / 2 drives both the disc clip and the trigger box,
// so a single number keeps them aligned (see FabButtonTrigger `size`).
export const FAB_SIZE_DEFAULT = 64;
export const FAB_SIZE_COMPACT = 38;

// Grow on hover via scale, not a larger clip radius: the clip is bound by the panel
// box, so a radius larger than the disc overflows the box edges and gets cut flat.
// scale grows the painted disc (and its wrapper drop-shadow) past the box cleanly.
export const COLLAPSED_HOVER_GROW_CLASS =
  "group-hover/fab:scale-115 group-hover/fab:duration-250";
